export enum EModalComponents {
  GENERATE_BALANCE_DIALOG = 'GENERATE_BALANCE_DIALOG',
  AIRDROP_TO_USER_DIALOG = 'AIRDROP_TO_USER_DIALOG',
  INVITE_NEW_USER = 'INVITE_NEW_USER',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  CONFIRM_AIRDROP = 'CONFIRM_AIRDROP',
  CONFIRM_VISIBILITY_CHANGE = 'CONFIRM_VISIBILITY_CHANGE'
}
